module.exports = __webpack_public_path__ + "static/img/ent-detail-15.42babdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-15.jpg
// module id = l5Ul
// module chunks = 52